export { VSkeletonLoader } from './VSkeletonLoader'
